import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Lenis from 'lenis';

// Momentum/inertia smooth scrolling (the Izanami "cinematic scroll" feel),
// applied globally. Respects reduced motion. Skipped on the /admin route so
// the admin dashboard keeps native scrolling (its nested scroll areas and
// panels behave exactly as before). Nested scroll containers elsewhere that
// opt out via `data-lenis-prevent` also keep native scrolling.
const SmoothScroll = ({ children }) => {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  useEffect(() => {
    if (isAdmin) return; // native scrolling for the admin dashboard

    const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
    let cleanup = () => {};
    const setup = () => {
      cleanup();
      if (preference.matches) return;

    const lenis = new Lenis({
      duration: 0.65,
      anchors: { get immediate() { return document.documentElement.dataset.input === 'keyboard'; } },
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      wheelMultiplier: 1,
      touchMultiplier: 1.5,
    });

    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    cleanup = () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
    };
    setup();
    preference.addEventListener('change', setup);
    return () => { cleanup(); preference.removeEventListener('change', setup); };
  }, [isAdmin]);

  return <>{children}</>;
};

export default SmoothScroll;
